(() => {
  const TITLE_HAS_EGIFT = 'すでにeギフトで贈る商品がカートに入っています';
  const TITLE_HAS_REGULAR = 'すでに通常購入の商品がカートに入っています';
  const TITLE_FEE_ALREADY = 'すでにeギフト専用ラッピング手数料がカートに入っています';
  const BODY = '通常購入とeギフトで贈る商品は同時に購入できません。\nお手数ですが別々に注文いただくか、カート内の商品を削除してから再度ご注文ください。';
  const BODY_FEE_ALREADY =
    'eギフト商品を複数ラッピングご希望の場合、おまとめラッピングとなります。1注文につきラッピング手数料1点にて承ります。\nラッピング手数料が複数回選択された場合は、自動で1点に調整いたします。';
  const NOTE_FEE_ALREADY = 'ギフト商品のみをカートに追加済みします。';
  const CLOSE_LABEL = '商品画面に戻る';
  const ABOUT_HREF = 'https://shop.kawabe.co.jp/pages/about-egift';
  const FEE_PRODUCT_TYPE = 'eギフト手数料';
  const FEE_SKUS = ['98900006'];
  const FEE_VARIANT_IDS = ['47012932124847'];

  let dialogEl = null;
  let nativeFetch = null;
  const productTypeByVariant = {};
  const accessoryByVariant = {};
  FEE_VARIANT_IDS.forEach((id) => {
    accessoryByVariant[id] = true;
  });

  function storePath(path) {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const base = root.endsWith('/') ? root : `${root}/`;
    return `${base}${String(path || '').replace(/^\//, '')}`;
  }

  function isAccessoryType(type) {
    const normalized = String(type || '').trim();
    return normalized === FEE_PRODUCT_TYPE || normalized === 'OPTION';
  }

  function isFeeVariantId(id) {
    const normalized = String(id || '').trim();
    return Boolean(normalized && (FEE_VARIANT_IDS.indexOf(normalized) !== -1 || accessoryByVariant[normalized]));
  }

  function isAccessoryItem(item) {
    if (!item) return false;
    if (isAccessoryType(item.product_type) || isAccessoryType(item.type)) return true;
    const sku = String(item.sku || '').trim();
    if (sku && FEE_SKUS.indexOf(sku) !== -1) return true;
    const title = String(item.product_title || item.title || '');
    if (title.indexOf('ラッピング手数料') !== -1 || title.indexOf('Egift専用') !== -1) return true;
    return isFeeVariantId(variantIdOf(item));
  }

  function isEgiftKey(rawKey) {
    const key = String(rawKey || '').toLowerCase();
    if (!key) return false;
    return (
      key === 'ギフト購入' ||
      key === 'e-gift' ||
      key === 'egift' ||
      key.indexOf('e-gift') !== -1 ||
      key.indexOf('ギフト購入') !== -1 ||
      key.indexOf('anygift') !== -1
    );
  }

  function isEgiftValue(rawValue) {
    const value = String(rawValue == null ? '' : rawValue).trim();
    if (!value) return false;
    const lower = value.toLowerCase();
    return !(value === '無効' || lower === 'off' || lower === 'false' || lower === '0' || lower === 'no');
  }

  function propertiesAreEgift(props) {
    if (!props) return false;
    if (Array.isArray(props)) {
      return props.some((entry) => {
        if (!entry) return false;
        const key = entry.name || entry.key || entry[0];
        const value = entry.value != null ? entry.value : entry[1];
        return isEgiftKey(key) && (value == null || isEgiftValue(value));
      });
    }
    return Object.keys(props).some((key) => isEgiftKey(key) && isEgiftValue(props[key]));
  }

  function isEgiftItem(item) {
    if (!item || isAccessoryItem(item)) return false;
    if (propertiesAreEgift(item.properties)) return true;
    const id = variantIdOf(item);
    return Boolean(id && pageEgiftVariantIds()[id]);
  }

  function isRegularItem(item) {
    if (!item || isAccessoryItem(item)) return false;
    return !isEgiftItem(item);
  }

  function variantIdOf(item) {
    if (!item) return '';
    const id = item.id || item.variant_id;
    return id == null || id === '' ? '' : String(id);
  }

  function rememberCartTypes(cart) {
    ((cart && cart.items) || []).forEach((item) => {
      const id = variantIdOf(item);
      if (!id) return;
      if (item.product_type) productTypeByVariant[id] = item.product_type;
      if (isAccessoryItem(item)) accessoryByVariant[id] = true;
    });
  }

  function handleCandidates(name) {
    const raw = String(name || '').trim();
    if (!raw) return [];
    const lower = raw.toLowerCase();
    const handleized = lower
      .replace(/['’]/g, '')
      .replace(/[^0-9A-Za-z\u0080-\uFFFF]+/g, '-')
      .replace(/^-+|-+$/g, '');
    return [...new Set([handleized, lower, raw])];
  }

  async function readJson(path) {
    const response = await nativeFetch(storePath(path), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) return null;
    try {
      return await response.json();
    } catch (error) {
      return null;
    }
  }

  async function productTypeForVariant(variantId) {
    if (!variantId) return '';
    if (Object.prototype.hasOwnProperty.call(productTypeByVariant, variantId)) {
      return productTypeByVariant[variantId];
    }

    let type = '';

    try {
      const variant = await readJson(`variants/${variantId}.js`);
      const candidates = handleCandidates(variant && variant.name);
      for (let i = 0; i < candidates.length; i++) {
        const product = await readJson(`products/${encodeURIComponent(candidates[i])}.js`);
        if (!product) continue;
        type = product.type || product.product_type || '';
        if (type) break;
      }
    } catch (error) {
      type = '';
    }

    productTypeByVariant[variantId] = type;
    return type;
  }

  function addingIsAccessory(item) {
    if (!item) return false;
    if (isAccessoryItem(item) || isFeeVariantId(variantIdOf(item))) return true;
    if (propertiesAreEgift(item.properties)) return false;
    const id = variantIdOf(item);
    if (id && !accessoryByVariant[id]) {
      productTypeForVariant(id)
        .then((type) => {
          if (isAccessoryType(type) && id) accessoryByVariant[id] = true;
        })
        .catch(() => {});
    }
    return false;
  }

  function requestUrl(input) {
    if (typeof input === 'string') return input;
    if (input instanceof URL) return input.href;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function isCartAddUrl(url) {
    try {
      const path = new URL(url, window.location.origin).pathname;
      return /\/cart\/add(\.js)?$/.test(path);
    } catch (error) {
      return false;
    }
  }

  function itemsFromObject(data) {
    if (!data || typeof data !== 'object') return [];
    if (Array.isArray(data.items)) return data.items;
    if (data.items && typeof data.items === 'object') {
      return Object.keys(data.items).map((key) => data.items[key]);
    }
    if (data.id || data.variant_id || data.properties) return [data];
    return [];
  }

  function itemsFromFormData(formData) {
    const grouped = {};
    const root = { properties: {} };

    formData.forEach((value, key) => {
      const itemMatch = key.match(/^items\[(\d+)\]\[(.+)\]$/);
      const propMatch = key.match(/^items\[(\d+)\]\[properties\]\[(.+)\]$/);
      const rootPropMatch = key.match(/^properties\[(.+)\]$/);

      if (propMatch) {
        const index = propMatch[1];
        grouped[index] = grouped[index] || { properties: {} };
        grouped[index].properties[propMatch[2]] = value;
        return;
      }

      if (itemMatch) {
        const index = itemMatch[1];
        grouped[index] = grouped[index] || { properties: {} };
        grouped[index][itemMatch[2]] = value;
        return;
      }

      if (rootPropMatch) {
        root.properties[rootPropMatch[1]] = value;
        return;
      }

      if (key === 'id' || key === 'variant_id' || key === 'quantity') root[key] = value;
    });

    const items = Object.keys(grouped).map((index) => grouped[index]);
    if (items.length) return items;
    if (root.id || Object.keys(root.properties).length) return [root];
    return [];
  }

  async function itemsFromBody(body) {
    if (!body) return [];
    if (body instanceof FormData) return itemsFromFormData(body);
    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      return itemsFromFormData(body);
    }
    if (typeof body === 'string') {
      try {
        return itemsFromObject(JSON.parse(body));
      } catch (error) {
        return itemsFromFormData(new URLSearchParams(body));
      }
    }
    if (typeof Blob !== 'undefined' && body instanceof Blob) {
      return itemsFromBody(await body.text());
    }
    return [];
  }

  async function readAddItems(input, init) {
    const fromInit = await itemsFromBody(init && init.body);
    if (fromInit.length) return fromInit;

    if (input && typeof input.clone === 'function') {
      try {
        const cloned = input.clone();
        if (typeof cloned.formData === 'function') {
          const fromRequest = await itemsFromBody(await cloned.formData());
          if (fromRequest.length) return fromRequest;
        }
      } catch (error) {
        // Keep going and try text/json.
      }
      try {
        return itemsFromBody(await input.clone().text());
      } catch (error) {
        return [];
      }
    }

    return [];
  }

  function pageEgiftVariantIds() {
    const ids = {};
    document.querySelectorAll('.buy-buttons-block[data-purchase-mode="egift"]').forEach((root) => {
      const form = root.closest('form') || root.querySelector('form');
      if (!form) return;
      const input = form.querySelector('[name="id"]');
      const id = input && input.value != null ? String(input.value).trim() : '';
      if (id) ids[id] = true;
    });
    return ids;
  }

  function addingLooksEgift(item) {
    if (propertiesAreEgift(item && item.properties)) return true;
    const id = variantIdOf(item);
    return Boolean(id && pageEgiftVariantIds()[id]);
  }

  function classifyAdding(addingItems) {
    const kinds = addingItems.map((item) => {
      if (addingIsAccessory(item)) return 'accessory';
      if (addingLooksEgift(item) || isEgiftPurchasePage()) return 'egift';
      return 'regular';
    });

    return {
      addingEgift: kinds.some((kind) => kind === 'egift'),
      addingRegular: kinds.some((kind) => kind === 'regular'),
      addingAccessory: kinds.some((kind) => kind === 'accessory'),
    };
  }

  function cartHasEgiftBody(cart) {
    return ((cart && cart.items) || []).some(isEgiftItem);
  }

  function cartFeeQuantity(cart) {
    return ((cart && cart.items) || [])
      .filter(isAccessoryItem)
      .reduce((sum, item) => sum + itemQuantity(item), 0);
  }

  function isEgiftPurchasePage() {
    return Boolean(document.querySelector('.buy-buttons-block[data-purchase-mode="egift"]'));
  }

  function mixKind(cart, flags) {
    const cartItems = (cart && cart.items) || [];
    const hasEgiftBody = cartHasEgiftBody(cart);
    const hasEgift = hasEgiftBody || cartItems.some(isAccessoryItem);
    const hasRegular = cartItems.some(isRegularItem);
    const hasFee = cartFeeQuantity(cart) >= 1;
    const hasNonFee = cartItems.some((item) => !isAccessoryItem(item));

    if (flags.addingAccessory && !flags.addingEgift && !hasEgiftBody) {
      if (hasRegular) return 'skip-fee';
      if (!hasNonFee && !isEgiftPurchasePage()) return 'skip-fee';
    }
    if (flags.addingAccessory && hasFee) {
      return flags.addingEgift ? 'fee-already-keep' : 'fee-already';
    }
    if (!cartItems.length) return '';
    if (flags.addingEgift && hasRegular) return 'has-regular';
    if (hasEgift && !flags.addingEgift && !flags.addingAccessory) {
      if (isEgiftPurchasePage() && hasFee) return '';
      return 'has-egift';
    }
    return '';
  }

  function ensureDialog() {
    if (dialogEl) return dialogEl;
    dialogEl = document.createElement('div');
    dialogEl.className = 'wb-anygift-mix';
    dialogEl.hidden = true;
    dialogEl.innerHTML =
      '<div class="wb-anygift-mix__panel" role="dialog" aria-modal="true" aria-labelledby="wb-anygift-mix-title">' +
      '<div class="wb-anygift-mix__inner">' +
      '<p class="wb-anygift-mix__title" id="wb-anygift-mix-title"></p>' +
      '<p class="wb-anygift-mix__note" hidden></p>' +
      '<p class="wb-anygift-mix__body"></p>' +
      '<button type="button" class="wb-anygift-mix__close"></button>' +
      '<p class="wb-anygift-mix__about">eギフトについて詳しくは<a href="' +
      ABOUT_HREF +
      '" target="_blank" rel="noreferrer">こちら</a></p>' +
      '</div>' +
      '</div>';
    dialogEl.querySelector('.wb-anygift-mix__body').textContent = BODY;
    dialogEl.querySelector('.wb-anygift-mix__close').textContent = CLOSE_LABEL;
    dialogEl.querySelector('.wb-anygift-mix__close').addEventListener('click', () => {
      dialogEl.hidden = true;
    });
    dialogEl.addEventListener('click', (event) => {
      if (event.target === dialogEl) dialogEl.hidden = true;
    });
    document.body.appendChild(dialogEl);
    return dialogEl;
  }

  function showDialog(kind) {
    const el = ensureDialog();
    const title =
      kind === 'fee-already'
        ? TITLE_FEE_ALREADY
        : kind === 'has-regular'
          ? TITLE_HAS_REGULAR
          : TITLE_HAS_EGIFT;
    el.querySelector('.wb-anygift-mix__title').textContent = title;
    el.querySelector('.wb-anygift-mix__body').textContent =
      kind === 'fee-already' ? BODY_FEE_ALREADY : BODY;
    const note = el.querySelector('.wb-anygift-mix__note');
    if (kind === 'fee-already') {
      note.textContent = NOTE_FEE_ALREADY;
      note.hidden = false;
    } else {
      note.textContent = '';
      note.hidden = true;
    }
    el.hidden = false;
  }

  const style = document.createElement('style');
  style.textContent =
    '.wb-anygift-mix{position:fixed;inset:0;z-index:2147483646;display:flex;align-items:center;justify-content:center;padding:16px;background:rgb(0 0 0 / 45%)}' +
    '.wb-anygift-mix[hidden]{display:none}' +
    '.wb-anygift-mix__panel{width:min(64rem,100%);border-radius:10px;background:#fff;color:#111;text-align:center;box-shadow:0 25px 50px -12px rgb(0 0 0 / 25%)}' +
    '.wb-anygift-mix__inner{width:100%;max-width:520px;margin:0 auto;padding:80px 16px}' +
    '.wb-anygift-mix__title{margin:0 0 20px;font-weight:700;font-size:18px;line-height:1.6;color:#d42828;white-space:pre-wrap}' +
    '.wb-anygift-mix__note{margin:0 0 20px;font-weight:700;font-size:16px;line-height:1.6;color:#1aa7b8}' +
    '.wb-anygift-mix__note[hidden]{display:none}' +
    '.wb-anygift-mix__body{margin:0 0 80px;font-weight:600;font-size:15px;line-height:1.6;white-space:pre-wrap}' +
    '.wb-anygift-mix__close{display:inline-flex;align-items:center;justify-content:center;width:100%;max-width:280px;margin:0 auto 40px;padding:20px 32px;border:0;border-radius:999px;background:linear-gradient(90deg,#3bb8d4,#70ddd8);color:#fff;font-size:15px;font-weight:700;cursor:pointer}' +
    '.wb-anygift-mix__about{margin:0;font-size:16px;font-weight:600}' +
    '.wb-anygift-mix__about a{color:inherit;text-decoration:underline}';
  document.head.appendChild(style);

  nativeFetch = window.fetch.bind(window);
  let lastCart = null;

  function isCartChangeUrl(url) {
    try {
      const path = new URL(url, window.location.origin).pathname;
      return /\/cart\/(change|update)(\.js)?$/.test(path);
    } catch (error) {
      return false;
    }
  }

  function jsonResponse(data) {
    return new Response(JSON.stringify(data), {
      status: 200,
      headers: { 'Content-Type': 'application/json' },
    });
  }

  function notifyCart(cart) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          data: {
            itemCount: cart && cart.item_count,
            source: 'wb-anygift-mix',
            sections: cart && cart.sections,
          },
        },
      })
    );
  }

  async function currentCart() {
    const cart = await nativeFetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' },
    }).then((response) => response.json());
    rememberCartTypes(cart);
    lastCart = cart;
    return cart;
  }

  async function readRequestMeta(input, init) {
    const fromBody = async (body) => {
      if (!body) return {};
      if (body instanceof FormData) {
        return {
          sections: body.get('sections') || '',
          sections_url: body.get('sections_url') || '',
        };
      }
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        return {
          sections: body.get('sections') || '',
          sections_url: body.get('sections_url') || '',
        };
      }
      if (typeof body === 'string') {
        try {
          const data = JSON.parse(body);
          return {
            sections: data.sections || '',
            sections_url: data.sections_url || '',
          };
        } catch (error) {
          const params = new URLSearchParams(body);
          return {
            sections: params.get('sections') || '',
            sections_url: params.get('sections_url') || '',
          };
        }
      }
      return {};
    };

    const fromInit = await fromBody(init && init.body);
    if (fromInit.sections || fromInit.sections_url) return fromInit;
    if (input && typeof input.clone === 'function') {
      try {
        return fromBody(await input.clone().text());
      } catch (error) {
        return fromInit;
      }
    }
    return fromInit;
  }

  function itemQuantity(item) {
    const qty = Number(item && item.quantity);
    return Number.isFinite(qty) && qty > 0 ? qty : 0;
  }

  function shouldStripAllFees(cart) {
    const items = (cart && cart.items) || [];
    const nonFee = items.filter((item) => !isAccessoryItem(item));
    if (!nonFee.length) return true;
    return !nonFee.some(isEgiftItem);
  }

  async function normalizeFees(cart, meta, options) {
    const stripOrphans = Boolean(options && options.stripOrphans);
    const items = (cart && cart.items) || [];
    const fees = items.filter(isAccessoryItem);
    if (!fees.length) return { cart, changed: false, capped: false };

    const feeQty = fees.reduce((sum, item) => sum + itemQuantity(item), 0);
    const updates = {};
    let capped = false;

    if (stripOrphans && shouldStripAllFees(cart)) {
      fees.forEach((item) => {
        const key = item.key || item.id || item.variant_id;
        if (key) updates[key] = 0;
      });
    } else if (feeQty > 1) {
      let remaining = 1;
      fees.forEach((item) => {
        const key = item.key || item.id || item.variant_id;
        if (!key) return;
        const qty = itemQuantity(item);
        const nextQty = Math.min(qty, remaining);
        remaining -= nextQty;
        if (nextQty !== qty) updates[key] = nextQty;
      });
      capped = true;
    }

    if (!Object.keys(updates).length) return { cart, changed: false, capped: false };

    const payload = { updates };
    if (meta && meta.sections) payload.sections = meta.sections;
    if (meta && meta.sections_url) payload.sections_url = meta.sections_url;

    const next = await nativeFetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    }).then((response) => response.json());
    rememberCartTypes(next);
    lastCart = next;
    notifyCart(next);
    return { cart: next, changed: true, capped };
  }

  function classifyFlags(addingItems) {
    return addingItems.length
      ? classifyAdding(addingItems)
      : isEgiftPurchasePage()
        ? { addingEgift: true, addingRegular: false, addingAccessory: false }
        : { addingEgift: false, addingRegular: true, addingAccessory: false };
  }

  async function decideKind(addingItems) {
    const flags = classifyFlags(addingItems);
    if (lastCart) {
      currentCart().catch(() => {});
      return { kind: mixKind(lastCart, flags), cart: lastCart };
    }
    const cart = await currentCart();
    return { kind: mixKind(cart, flags), cart };
  }

  function objectFromBody(body) {
    if (!body) return {};
    if (body instanceof FormData || (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams)) {
      const data = {};
      body.forEach((value, key) => {
        data[key] = value;
      });
      return data;
    }
    if (typeof body === 'string') {
      try {
        return JSON.parse(body);
      } catch (error) {
        return Object.fromEntries(new URLSearchParams(body));
      }
    }
    return {};
  }

  function changeIncreasesFee(payload, cart) {
    const items = (cart && cart.items) || [];
    if (!payload || !items.some(isAccessoryItem)) return false;

    if (payload.updates && typeof payload.updates === 'object') {
      return Object.keys(payload.updates).some((key) => {
        const item = items.find(
          (entry) =>
            String(entry.key) === String(key) ||
            String(entry.id) === String(key) ||
            String(entry.variant_id) === String(key)
        );
        if (!item || !isAccessoryItem(item)) return false;
        return Number(payload.updates[key]) > itemQuantity(item);
      });
    }

    const qty = Number(payload.quantity);
    if (!Number.isFinite(qty)) return false;
    let item = null;
    const line = Number(payload.line);
    if (line >= 1) item = items[line - 1];
    const id = payload.id || payload.variant_id || payload.key;
    if (!item && id) {
      item = items.find(
        (entry) =>
          String(entry.key) === String(id) ||
          String(entry.id) === String(id) ||
          String(entry.variant_id) === String(id)
      );
    }
    return Boolean(item && isAccessoryItem(item) && qty > itemQuantity(item));
  }

  async function readChangePayload(input, init) {
    if (init && init.body) return objectFromBody(init.body);
    if (input && typeof input.clone === 'function') {
      try {
        const cloned = input.clone();
        if (typeof cloned.formData === 'function') {
          const form = await cloned.formData();
          if (form) return objectFromBody(form);
        }
      } catch (error) {
        // Try text next.
      }
      try {
        return objectFromBody(await input.clone().text());
      } catch (error) {
        return {};
      }
    }
    return {};
  }

  async function guardCartAdd(input, init) {
    const addingItems = await readAddItems(input, init);
    const { kind, cart } = await decideKind(addingItems);
    if (kind === 'skip-fee') return { blocked: true, skip: true, cart };
    if (kind === 'fee-already') {
      showDialog(kind);
      return { blocked: true, skip: true, cart };
    }
    if (kind === 'fee-already-keep') {
      showDialog('fee-already');
      return { blocked: false };
    }
    if (kind) {
      showDialog(kind);
      return { blocked: true, skip: false, cart };
    }
    return { blocked: false };
  }

  async function afterCartWrite(cart, meta, options) {
    const alertOnCap = !options || options.alert !== false;
    const result = await normalizeFees(cart, meta, options);
    if (alertOnCap && result.capped) showDialog('fee-already');
    return result;
  }

  window.fetch = function (input, init) {
    const url = requestUrl(input);

    if (isCartAddUrl(url)) {
      return (async () => {
        try {
          const result = await guardCartAdd(input, init);
          if (result.blocked && result.skip) return jsonResponse(result.cart);
          if (result.blocked) {
            return Promise.reject(new DOMException('wb-anygift-mix', 'AbortError'));
          }
        } catch (error) {
          if (error && error.name === 'AbortError') throw error;
        }
        const response = await nativeFetch(input, init);
        try {
          const data = await response.clone().json();
          if (!data || data.errors || data.status === 422) return response;
          rememberCartTypes(data);
          const { changed, capped } = await afterCartWrite(
            await currentCart(),
            await readRequestMeta(input, init),
            { stripOrphans: false }
          );
          if (!changed && !capped) return response;
        } catch (error) {
          return response;
        }
        return response;
      })();
    }

    if (isCartChangeUrl(url)) {
      return (async () => {
        try {
          if (changeIncreasesFee(await readChangePayload(input, init), lastCart)) {
            showDialog('fee-already');
          }
        } catch (error) {
          // Continue and still cap after the write.
        }
        const response = await nativeFetch(input, init);
        try {
          const data = await response.clone().json();
          if (!data || data.errors) return response;
          rememberCartTypes(data);
          const { cart, changed } = await afterCartWrite(data, await readRequestMeta(input, init), {
            stripOrphans: true,
          });
          if (!changed) return response;
          return jsonResponse(cart);
        } catch (error) {
          return response;
        }
      })();
    }

    return nativeFetch(input, init);
  };

  const nativeXhrOpen = XMLHttpRequest.prototype.open;
  const nativeXhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._wbMixMethod = method;
    this._wbMixUrl = url;
    return nativeXhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    const method = String(this._wbMixMethod || '').toUpperCase();
    const url = String(this._wbMixUrl || '');
    if (method !== 'POST') return nativeXhrSend.apply(this, arguments);

    if (isCartChangeUrl(url)) {
      try {
        if (changeIncreasesFee(objectFromBody(body), lastCart)) showDialog('fee-already');
      } catch (error) {
        // Continue and still cap after the write.
      }
      this.addEventListener('load', () => {
        currentCart()
          .then((cart) => afterCartWrite(cart, null, { stripOrphans: true }))
          .then(({ changed }) => {
            if (changed && /\/cart\/?$/.test(window.location.pathname)) window.location.reload();
          })
          .catch(() => {});
      });
      return nativeXhrSend.apply(this, arguments);
    }

    if (!isCartAddUrl(url)) return nativeXhrSend.apply(this, arguments);

    const xhr = this;
    const args = arguments;
    xhr.addEventListener('load', () => {
      currentCart()
        .then((cart) => afterCartWrite(cart, null, { stripOrphans: false }))
        .then(({ changed }) => {
          if (changed && /\/cart\/?$/.test(window.location.pathname)) window.location.reload();
        })
        .catch(() => {});
    });
    (async () => {
      try {
        const result = await guardCartAdd({ url }, { body });
        if (result.blocked && result.skip) return;
        if (result.blocked) return;
      } catch (error) {
        // Fall through and send the original request.
      }
      nativeXhrSend.apply(xhr, args);
    })();
  };

  async function sweepOrphanFees() {
    try {
      const { changed } = await afterCartWrite(await currentCart(), null, {
        alert: false,
        stripOrphans: true,
      });
      if (changed && /\/cart\/?$/.test(window.location.pathname)) window.location.reload();
    } catch (error) {
      // Ignore sweep failures.
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sweepOrphanFees);
  } else {
    sweepOrphanFees();
  }
})();
